<template>
  <div class="task-response" data-qid="task-client-response-options">
    <div class="task-response__label">
      {{ $t('tasks.modal.response_label') }}
      <span v-if="selectedTask.add_response_doc === 'Mandatory'" class="text-red">*</span>
    </div>
    <div v-if="selectedTask.response_type_doc !== 'Datepicker'" class="task-choices">
      <span v-for="option in allAnswersDoc"
            :key="'answer-doc-' + option.title"
            class="task-choice"
            :style="choiceStyle(option)"
            :class="['task-choice--option', {'task-choice--on': selectedTask.response_doc === option.title, 'disabled': !canEdit}]"
            @click="chooseAnswer(option)"
            data-qid="task-client-response-option"
      >
        <font-awesome-icon v-if="iconOf(option)"
                           :icon="iconOf(option).icon"
                           class="task-choice__icon"
                           :style="iconOf(option).style"
        />
        <font-awesome-icon v-else :icon="selectedTask.response_doc === option.title ? 'dot-circle' : 'circle'"/>{{ option.title }}
      </span>
      <span class="task-choices__hint" v-if="canEdit">{{ $t('tasks.v2.saved_when_clicked') }}</span>
    </div>
    <div v-else class="task-choices">
      <datepicker v-model="selectedDateDoc"
                  class="date-picker"
                  calendar-class="right"
                  :clear-button="true"
                  :disabled="!canEdit"
                  :placeholder="$t('tasks.modal.response_label')"
      ></datepicker>
      <b-button v-if="canEdit"
                size="sm"
                variant="success"
                @click="updateResponseDoc(selectedTask)"
      >{{ $t('tasks.modal.save') }}</b-button>
    </div>
  </div>
</template>

<script>
import assessmentSingleTaskProxy from './assessmentSingleTaskProxy';
import Datepicker from 'vuejs-datepicker';
import { iconForOption } from './responseIcon';
import { optionStyle } from '@/util/dropdownOptions.js';

// The client's response on the documentation collection, saved when clicked
export default {
  name: 'EngagementTaskClientResponse',
  mixins: [assessmentSingleTaskProxy],
  components: {
    Datepicker
  },
  computed: {
    canEdit() {
      return this.selectedTask && !this.readOnly && this.selectedTask.data_status !== 'completed' && !this.dataCollectionLocked && !this.isInOeTesting;
    }
  },
  methods: {
    // The icon and colour the option was given
    iconOf(option) {
      return iconForOption(option);
    },
    chooseAnswer(option) {
      if (!this.canEdit || this.selectedTask.response_doc === option.title) {
        return;
      }
      this.selectedAnswerDoc = option;
      this.updateResponseDoc(this.selectedTask);
    },
    // The chosen option is tinted in its own colour, like its pill on the template
    choiceStyle(option) {
      const style = optionStyle(option);
      return { '--c': style.hex, '--t': style.text };
    }
  }
};
</script>
